import { Component } from "@angular/core";
import { CustomModal } from "../../../core/components/base-modals";
import { CashPlusFacade } from "@modules/cashplus/+state/cashplus.facade";
import { Observable } from "rxjs";
import { IRolloutList } from "@modules/cashplus/entities/cashplus.model";

@Component({
	templateUrl: "./cashplus-roll-info-modal.component.html",
	styleUrls: ["./cashplus-roll-info-modal.component.scss"],
	standalone: false
})
export class CashplusRollInfoModalComponent extends CustomModal {
	public fiatList$: Observable<IRolloutList[]> = this.cashPlusFacade.getFiatRollOutTime$();
	public constructor(private readonly cashPlusFacade: CashPlusFacade) {
		super();
	}
}
